import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-402">
      <Navbar data-id="element-403" />
      <main className="pt-32 pb-24" data-id="element-404">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-405">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-406">
            Cookie Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-407">
            <p className="font-medium" data-id="element-408">Last updated: 14 December 2025</p>

            <p data-id="element-409">
              This Cookie Policy explains how KittyPot Ltd ("Company," "we,"
              "us," and "our") uses cookies and similar technologies to
              recognize you when you visit our website at
              https://www.kittypot.com ("Website"). It outlines what cookies
              are, why we use them, and your rights to control their usage.
            </p>

            <p data-id="element-410">
              In some cases, we may use cookies to collect personal information,
              or information that becomes personal when combined with other
              data.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-411">
              1. WHAT ARE COOKIES?
            </h2>
            <p data-id="element-412">
              Cookies are small data files placed on your computer or mobile
              device when you visit a website. These files are commonly used by
              website owners to make websites work or perform more efficiently
              and to provide reporting data.
            </p>
            <p data-id="element-413">
              Cookies set by the website owner (in this case, KittyPot Ltd) are
              referred to as "first-party cookies." Cookies set by parties other
              than the website owner are known as "third-party cookies."
              Third-party cookies allow the provision of third-party services on
              the website (e.g., advertising, interactive content, and
              analytics). These third parties may recognize your computer when
              you visit our website as well as when you visit other websites.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-414">
              2. WHY DO WE USE COOKIES?
            </h2>
            <p data-id="element-415">
              We use both first- and third-party cookies for various reasons.
              Some cookies are essential for technical reasons to make our
              website operate ("essential" or "strictly necessary" cookies).
              Other cookies help us track and target the interests of our users
              to improve their experience.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-416">
              3. HOW CAN I CONTROL COOKIES?
            </h2>
            <p data-id="element-417">
              You have the right to decide whether to accept or reject cookies.
              You can manage your cookie preferences via the Cookie Consent
              Manager. Essential cookies cannot be rejected as they are strictly
              necessary for the functionality of the website.
            </p>
            <p data-id="element-418">
              The Cookie Consent Manager is available through the notification
              banner and on our website. If you choose to reject cookies, you
              can still use our website, but some features may not be
              accessible. You can also configure your web browser to accept or
              reject cookies.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-419">
              Performance and Functionality Cookies
            </h3>
            <p data-id="element-420">
              These cookies enhance the performance and functionality of our
              website but are not essential.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-421">
              <li data-id="element-422">
                <strong data-id="element-423">Name:</strong> TS#
              </li>
              <li data-id="element-424">
                <strong data-id="element-425">Purpose:</strong> Enhances website security.
              </li>
              <li data-id="element-426">
                <strong data-id="element-427">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-428">
                <strong data-id="element-429">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-430">
                <strong data-id="element-431">Expires:</strong> Session
              </li>
            </ul>
            <ul className="list-disc pl-5 space-y-2 mt-4" data-id="element-432">
              <li data-id="element-433">
                <strong data-id="element-434">Name:</strong> XSRF-TOKEN
              </li>
              <li data-id="element-435">
                <strong data-id="element-436">Purpose:</strong> Prevents Cross-Site Request Forgery
                (CSRF).
              </li>
              <li data-id="element-437">
                <strong data-id="element-438">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-439">
                <strong data-id="element-440">Type:</strong> HTTP Cookie
              </li>
              <li data-id="element-441">
                <strong data-id="element-442">Expires:</strong> Session
              </li>
            </ul>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-443">
              Analytics and Customisation Cookies
            </h3>
            <p data-id="element-444">
              These cookies help us understand how our website is used and
              improve user experience.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-445">
              <li data-id="element-446">
                <strong data-id="element-447">Name:</strong> bolt-performance
              </li>
              <li data-id="element-448">
                <strong data-id="element-449">Purpose:</strong> Tracks performance metrics
              </li>
              <li data-id="element-450">
                <strong data-id="element-451">Provider:</strong> www.kittypot.com
              </li>
              <li data-id="element-452">
                <strong data-id="element-453">Type:</strong> Pixel Tracker
              </li>
              <li data-id="element-454">
                <strong data-id="element-455">Expires:</strong> Session
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-456">
              4. HOW CAN I CONTROL COOKIES ON MY BROWSER?
            </h2>
            <p data-id="element-457">
              You can manage cookies through your browser settings. Please refer
              to your browser's help section for guidance.
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-458">
              <li data-id="element-459">Chrome</li>
              <li data-id="element-460">Firefox</li>
              <li data-id="element-461">Safari</li>
              <li data-id="element-462">Edge</li>
              <li data-id="element-463">Opera</li>
            </ul>
            <p className="mt-4" data-id="element-464">
              You can also opt out of targeted advertising via:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-465">
              <li data-id="element-466">Digital Advertising Alliance</li>
              <li data-id="element-467">European Interactive Digital Advertising Alliance</li>
              <li data-id="element-468">Digital Advertising Alliance of Canada</li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-469">
              5. OTHER TRACKING TECHNOLOGIES
            </h2>
            <p data-id="element-470">
              We may use web beacons (tracking pixels) to measure website
              traffic and campaign effectiveness. These rely on cookies to
              function.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-471">
              6. FLASH COOKIES
            </h2>
            <p data-id="element-472">
              We may use Flash cookies for fraud prevention and service
              functionality. You can manage Flash cookies via Adobe Flash Player
              settings.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-473">
              7. TARGETED ADVERTISING
            </h2>
            <p data-id="element-474">
              Third-party advertisers may place cookies to deliver
              interest-based advertising. They do not collect personal data
              unless you provide it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-475">
              8. POLICY UPDATES
            </h2>
            <p data-id="element-476">
              We may update this Cookie Policy periodically for legal,
              regulatory, or operational reasons.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-477">
              9. Unicorn Platform Cookies
            </h2>
            <p data-id="element-478">
              Our website is built using Unicorn Platform, which uses essential
              cookies required for core functionality.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-479">
              10. CONTACT US
            </h2>
            <p data-id="element-480">
              If you have any questions about this Cookie Policy, please contact
              us at support@kittypot.com or by post:
            </p>
            <address className="not-italic mt-4" data-id="element-481">
              KittyPot Ltd
              <br data-id="element-482" />
              Flat 2 Minavon
              <br data-id="element-483" />
              Cardiff
              <br data-id="element-484" />
              South Glamorgan
              <br data-id="element-485" />
              CF14 6BE
              <br data-id="element-486" />
              United Kingdom
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-487" />
    </div>;
}